module.exports = __webpack_public_path__ + "img/3.201e8864.jpg";